import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useGetData } from "../../hooks/useGetData";

export const getAllNotifications = createAsyncThunk("notification/getAllNotifications", async (_, { rejectWithValue }) => {
  try {
    const res = await useGetData("notifications");
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

const initialState = {
  user: null,
  allNotifications: null,
  status: "idle",
  error: null,
};
export const notificationSlice = createSlice({
  name: "notification",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allNotifications = action.payload;
      })
      .addCase(getAllNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default notificationSlice.reducer;
